// Import React Library
import React from 'react';

// Import React Virtual DOM.
import ReactDOM from 'react-dom/client';

// Import Components
import App from './App';
import Error from './pages/Error';
import Login from './pages/Login';
import Productos from './pages/Productos';
import ProductsCrud from './pages/ProductsCrud';
import WorkWithUs from './pages/WorkWithUs';

// Import AuthProvider
import { AuthProvider } from "./components/context/AuthContext";

// Import Private Route
import PrivateRoute from './components/context/PrivateRoute';

// Import Routing System
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// Router Component
const router = createBrowserRouter([
  {
    path: '',
    element: <App />,
    errorElement : <Error />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/productos',
    element: <Productos />
  },
  {
    path: '/trabaja-con-nosotros',
    element: <WorkWithUs />
  },
  {
    path: '/crud',
    element: 
    <PrivateRoute>
      <ProductsCrud />
    </PrivateRoute>
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <RouterProvider router={router}/>
  </AuthProvider>
);